module.exports = __webpack_public_path__ + "static/evergy-33de1006fafae847310dd243907cdac8.png";